import { createFileRoute } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { DocumentsPage } from "../documents/documents-page.tsx";
import { loadDocuments } from "../documents/loaders.ts";
import { canBrowseDocuments } from "../documents/permissions.ts";
import { IndexPending } from "../shell/record-pending.tsx";
import { documentsSearch, retainPropertyFilter } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null || !canBrowseDocuments(viewer) ? (
    <NoAccessPage />
  ) : (
    <DocumentsPage viewer={viewer} />
  );
};

export const Route = createFileRoute("/_app/documents/")({
  staticData: { hasPropertyContext: true },
  validateSearch: documentsSearch,
  search: retainPropertyFilter(),
  loader: async ({ context }) => loadDocuments(context.data),
  pendingComponent: () => <IndexPending />,
  component: Page,
});
